import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Golds Gym Akurdi and by choosing the right plan and program I already achieved my ideal body!",
    name: 'ROHAN',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'Fitness Goal Achieved by Choosing Golds Gym',
    name: 'RAJU',
    status: 'COACH'
  },
  {
    image : image3,
    review:' Great Coaches, Great Gym, Great Equipments !',
    name: 'ANUJ',
    status: "SOFTWARE DEVELOPER"
  }
];
